import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChurchService } from 'src/app/church/church.service';
import { GroupService } from 'src/app/group/group.service';
import { MembersFileSendComponent } from 'src/app/members/members-file-send/members-file-send.component';
import { MembersService } from 'src/app/members/members.service';
import { User } from 'src/app/shared/interfaces/user.interface';
import { CITIES } from 'src/app/shared/static/cities.json';
import { states } from 'src/app/shared/static/states';
import { AccountService } from '../services/account.service';
import { MembersGetFile } from 'src/app/members/get-file/members-file-send.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CepService } from '../services/cep.service';

@Component({
  selector: 'app-novo-convertido',
  templateUrl: './novo-convertido.component.html',
  styleUrls: ['./novo-convertido.component.css'],
})
export class NovoConvertidoComponent implements OnInit {
  form: FormGroup;
  genders = [
    { title: 'Masculino', value: 'M' },
    { title: 'Feminino', value: 'F' },
  ];
  states = states;
  cities = [];
  groups = [];
  id: number;
  functions = [];
  currentAvatar: string;
  members: User[] = [];
  churches;
  avatar: any;
  avatarData: { blob: any; originalFileName: string };
  originalFile: any;

  constructor(
    private memberService: MembersService,
    private accountService: AccountService,
    private toastr: ToastrService,
    private groupService: GroupService,
    private router: Router,
    private matDialog: MatDialog,
    private churchService: ChurchService,
    private sanitizer: DomSanitizer,
    private cepService: CepService
  ) {
    //this.states = states;
    this.getGroups();

    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      gender: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(100)]),
      phone_number: new FormControl('', [Validators.required]),
      bhirth_date: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      state_id: new FormControl('', []),
      city_id: new FormControl('', []),
      street: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      home_number: new FormControl('', [Validators.required]),
      complement: new FormControl('', [Validators.maxLength(100)]),
      how_arrived: new FormControl('', [Validators.maxLength(200)]),
      group_id: new FormControl('', []),
      discipler_id: new FormControl('', []),
      group_function_id: new FormControl('', []),
      cep: new FormControl('', [Validators.required, Validators.minLength(9)]),
      neighborhood: new FormControl('', [Validators.maxLength(100)]),
      cpf: new FormControl('', [Validators.maxLength(14)]),
    });
  }

  ngOnInit(): void {
    this.form.get('cep').valueChanges.subscribe((cep) => {
      if (cep.length == 9) {
        this.cepService.get(cep).then((res) => {
          const state = states.find((s) => s.Sigla == res.uf)?.ID;
          this.changeCity(state);
          this.form.patchValue({
            state_id: state,
            city_id: CITIES.find((s) => s.Nome.toLowerCase() == res.localidade.toLowerCase())?.ID,
            street: res.logradouro,
          });
        });
      }
    });
  }

  changeCity(CurrentState): void {
    if (CurrentState) {
      const citiesTemp = CITIES.filter((s) => {
        if (s.Estado == CurrentState) {
          return s;
        }
      });
      this.cities = citiesTemp;
    }
  }

  register(): void {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    let data: any = {};

    data.user_data = JSON.stringify(this.form.value);
    data.name = this.form.get('name').value;
    data.gender = this.form.get('gender').value;
    data.email = this.form.get('email').value;
    data.phone_number = this.form.get('phone_number').value;
    data.bhirth_date = this.form.get('bhirth_date').value;
    data.state_id = this.form.get('state_id').value;
    data.city_id = this.form.get('city_id').value;
    data.street = this.form.get('street').value;
    data.home_number = this.form.get('home_number').value;
    data.complement = this.form.get('complement').value;
    data.how_arrived = this.form.get('how_arrived').value;
    data.group_id = this.form.get('group_id').value;
    data.discipler_id = this.form.get('discipler_id').value;
    data.group_function_id = this.form.get('group_function_id').value;
    data.cep = this.form.get('cep').value;
    data.church_status = 'novo_convertido';
    data.neighborhood = this.form.get('neighborhood').value;
    data.cpf = this.form.get('cpf').value;

    this.accountService
      .newConvert(data)
      .then((res) => {
        this.form.reset();
        this.toastr.success(res.message);
        this.router.navigateByUrl('/');
      })
      .catch((err) => {
        console.log(err);
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  getGroups(): Promise<any> {
    return this.groupService
      .getAll()
      .then((res) => {
        this.groups = res;
      })
      .catch((err) => {
        console.log(err);
        this.toastr.error(err.error.message || 'Falha ao carregar células');
      });
  }

  getChurches() {
    this.churchService
      .get()
      .then((res) => {
        this.churches = res;
      })
      .catch((err) => {});
  }

  changeAvatar() {
    const dialog = this.matDialog
      .open(MembersGetFile, {
        width: '400px',
        height: '600px',
      })
      .afterClosed()
      .subscribe((afterClosedResult) => {
        this.originalFile = afterClosedResult.originalFile;
        const blobUrl = URL.createObjectURL(afterClosedResult.originalFile);
        this.avatar = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
        this.avatarData = afterClosedResult;
      });
  }
}
